module.exports = __webpack_public_path__ + "img/logo.a90f81c6.png";